<template>
    <v-container  grid-list-xs text-xs-center class="card text-center" >
        <v-layout justify-center> 
            <h2 class="font-weight-bold">Crear cuenta</h2>
        </v-layout>
        <div class="card-body">
            <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="validate()">
                <v-layout row >
                    <v-flex>
                        <v-text-field  label="Nombres"  v-model="users.nombres" :rules="[rules.required]" required>
                        </v-text-field>
                        <v-text-field  label="Apellidos"  v-model="users.apellidos" :rules="[rules.required]"  required>
                        </v-text-field>                                        
                        <v-layout justify-center  class="J-radio" style="margin-top: 13px">
                                <label for="Hombre" class="J-radio-container" style="margin-right:10px;">
                                    <input type="radio" v-model="users.gender" name="gender" id="Hombre" value="H">
                                    <span class="J-radio-checkmark"></span>
                                    <span>Hombre</span>
                                </label>
                                <label for="Mujer" class="J-radio-container" style="margin-right:10px;">
                                    <input type="radio" v-model="users.gender" name="gender" id="Mujer" value="M">
                                    <span class="J-radio-checkmark"></span>
                                    <span>Mujer</span>
                                </label>
                        </v-layout>
                        <v-layout>
                            <v-flex > 
                                <v-text-field label="Numero de telefono o celular" v-model="users.phone" :rules="[rules.required]" required type="number">
                                </v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout >
                            <v-flex > 
                                <v-text-field label="Email" v-model="users.email" :rules="[rules.required, rules.emailvalidate,rules.space]" required id="email">
                                </v-text-field>
                                <v-layout v-if="emailExist">
                                    <label class ="fas fa-exclamation-triangle"> Existe un Usuario con este email</label>
                                </v-layout>    
                            </v-flex>
                        </v-layout>
                        <v-layout >
                            <v-flex > 
                                <v-text-field id="userreg" label="Nombre de usuario" v-model="users.username" :rules="[rules.required,rules.space]" required
                                ></v-text-field>
                                <v-layout v-if="userNameExist">
                                    <label class ="fas fa-exclamation-triangle"> El nombre de usuario no esta disponible</label>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                        <!-- CONTRASEÑA -->
                        <v-layout >
                            <v-flex > 
                                <v-text-field 
                                    :append-icon="InputPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"
                                    :rules="[rules.required, rules.min]"
                                    :type="InputPassword ? 'text' : 'password'"
                                    name="input-10-2"
                                    v-model="passwordmodel"
                                    label="Contraseña"                              
                                    value=""
                                    class="input-group--focused"
                                    @click:append="InputPassword = !InputPassword"
                                    color="#000"
                                    required                    
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                        <!-- CONFIRMAR CONTRASEÑA-->
                        <v-layout >
                            <v-flex > 
                                <v-text-field :append-icon="ConfirmPassword ? 'fas fa-eye-slash' : 'fas fa-eye'" 
                                    :rules="[rules.required, rules.min, rules.passwordequal]" 
                                    :type="ConfirmPassword ? 'text' : 'password'" name="input-10-2" label="Confirmar Contraseña" value="" 
                                    class="input-group--focused" @click:append="ConfirmPassword = !ConfirmPassword" required >
                                </v-text-field>
                            </v-flex>
                        </v-layout>
                        <!-- BOTON REGISTRATE -->
                        <v-layout justify-center >                        
                            <v-btn :disabled="!valid" type="submit" depressed round color="#11679a" style="color:#fff;border:2px solid;border-radius: 10px 10px 10px 10px;width:90%">REGISTRATE</v-btn>                       
                        </v-layout>
                        <v-layout v-if="!isonlyregister" justify-center >                        
                            <v-btn @click="gologinuser" depressed round color="secondary" style="border:2px solid;border-radius: 10px 10px 10px 10px;width:90%">VOLVER</v-btn>                        
                        </v-layout>
                        <!-- TERMINO DE SERVICIO Y POLITICA DE PRIVACIDAD-->
                        <v-layout  >
                            <v-flex > 
                                <label>Al registrarte con nosotros aceptas nuestros</label>
                                <p> <a href="www.google.com">Termino de servicio y politica de privacidad </a > </p>
                            </v-flex>
                        </v-layout> 

                    </v-flex>
                </v-layout>
            </v-form>
        </div>
  </v-container>
</template>

<script>
    import { EventBus } from './../../../../helpers/eventbus/event-bus'
   import initVue from '../../../../helpers/initVue'
   import users from '../../../../models/user.js'
//import { EventBus } from '../../../../helpers/eventbus/event-bus';
    const moment = require('moment')
    const alertify = require('alertifyjs')
   export default {
    data () {
      return {
        isonlyregister:true,
        valid:true,
        InputPassword: false,
        ConfirmPassword: false,
        users:new users(),
        modalregister: false,
        session: false,
        passwordmodel: '',
        userNameExist: false,
        emailExist: false,
        rules: {
          required: value => !!value || 'requerido.',
          min: v => v.length >= 8 || 'Mínimo 8 caracteres',
        //   emailMatch: () => ('The email and password you entered don\'t match'),
            
        //   passwordvalidate: value => {
        //      const pattern = /^(?=.*\d)(?=.*[a-záéíóúüñ]).*[A-ZÁÉÍÓÚÜÑ]/
        //      return pattern.test(value) || 'Tu contraseña debe tener un carácter, una letra mayúscula, una minúscula y un número'
        //    },
          emailvalidate: value =>{
             const pattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
             return pattern.test(value) || 'El email debe contener @ y otros carácteres mas'
           },
           passwordequal: value =>{
             let passwordcondition = this.passwordmodel !== value
             return !passwordcondition || 'La contraseña no concuerda con lo anterior escrito'
           },
           space: value =>{
              const pattern = /\s/
              return !pattern.test(value) || 'No dejes espacios en blanco'
            }
        }
      }
    },
    
    mounted(){
        this.getidentity()
        let routeroot = this.$route.path === '/'
        this.isonlyregister = routeroot
     },
    methods: {
        gologinuser(){
          this.$emit('activeLogin',0)
        },

        /*******************************************************
 * * Obteniendo la identidad para validar el token
 *******************************************************/
        getidentity(){
            this.identity = initVue.getIdentity().identity
            this.token = initVue.getIdentity().token
            this.session = initVue.isLogged(this.identity, this.token)
            //console.log(this.identity)
        },
        /*
        goLogin(){
            this.$router.push('/login')
        },*/

        openmodalregister(){
            this.modalregister = true
        },

        
        /****************** * Guardar datos para identificar si el usuarios ha iniciado sesión ***************************************************+*/
        saveIdentity() {
            this.$store.dispatch('saveIdentity', this.identity)
            localStorage.setItem('iden', JSON.stringify(this.identity))
            this.$store.dispatch('saveToken', this.token)
            localStorage.setItem('tok', this.token)
        },

        validate() {
         if (this.$refs.form.validate()) {
           this.snackbar = true
           this.users.password=this.passwordmodel
           this.users.fullname=this.users.nombres+' '+ this.users.apellidos
           this.users.photo = '/img/resources/usuario.png'
           this.users.start_time_block = moment().toDate();
            this.axios.post('users/create',this.users)
            .then(res=>{
                this.identity = res.data.user
                this.token = res.data.token
                setTimeout(() => {
                        this.saveIdentity()
                        window.location = window.location.href
                }, 400)
            })
            .catch(err=>{
                let msg = err.response.data.message

                    if (msg === "El email ya existe") {
                        this.emailExist = true
                        document.getElementById('email').focus()
                        setTimeout(() => {
                            this.emailExist = false
                        }, 5000)
                    }else if (msg === "El nombre de usuario ya existe") {
                        this.userNameExist = true
                        document.getElementById('userreg').focus()
                        setTimeout(() => {
                            this.userNameExist = false
                        }, 5000)
                    }else if (msg === 'Todos los campos son necesarios') {
                        alertify.error(msg)
                    }
            })
         }
       },
     },
  }

</script>



